var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "37.368px",
    height: "37.386px",
    viewBox: "13.502 10.694 37.368 37.386",
    enableBackground: "new 13.502 10.694 37.368 37.386",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1664A5",
    d: "M32.159,10.694c10.28-0.024,18.704,8.367,18.711,18.642c0.007,10.307-8.319,18.688-18.618,18.744 c-10.33,0.058-18.748-8.345-18.75-18.713C13.501,19.054,21.829,10.718,32.159,10.694 M25.43,31.764h3.836v9.032h4.53v-9.031 c1.072,0,2.024,0.027,2.976-0.016c0.307-0.016,0.793-0.144,0.877-0.351c0.482-1.166,0.867-2.373,1.346-3.733h-5.089 c-0.579-4.418,0.487-5.574,5.054-5.475c0-0.992-0.042-1.988,0.016-2.979c0.039-0.712-0.265-1.016-0.916-1.13 c-3.547-0.624-7.856,0.204-8.651,5.624c-0.189,1.291-0.212,2.606-0.32,4.025H25.43V31.764z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.247be4ee4a20a3cc5951130c9e22467c.svg";
export { ForwardRef as ReactComponent };